import { createSvgIcon } from '@mui/material';

export const CloseSvgIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
        <path d="M12.7279 21.2132L21.2132 12.7279M12.7279 12.7279L21.2132 21.2132" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'CloseSvgIcon'
)